import { PositionEnum } from './enums/position.enum';

export class Position {
  code!: PositionEnum;
  labelKey!: string;
  constructor(data: any = {}) {
    Object.assign(this, data);
  }
}

export const LIST_POSITION: { [key: string]: Position } = {
  COMPANY_DIRECTOR: new Position({ code: PositionEnum.COMPANY_DIRECTOR, labelKey: 'LABEL.POSITION.COMPANY_DIRECTOR' }),
  COMPANY_ACCOUNTANT: new Position({ code: PositionEnum.COMPANY_ACCOUNTANT, labelKey: 'LABEL.POSITION.COMPANY_ACCOUNTANT' }),
  COMPANY_HUMAN_RESOURCE_MANAGER: new Position({ code: PositionEnum.COMPANY_HUMAN_RESOURCE_MANAGER, labelKey: 'LABEL.POSITION.COMPANY_HUMAN_RESOURCE_MANAGER' }),
  COMPANY_SALES_ADMINISTRATOR: new Position({ code: PositionEnum.COMPANY_SALES_ADMINISTRATOR, labelKey: 'LABEL.POSITION.COMPANY_SALES_ADMINISTRATOR' }),
  COMPANY_MARKETING_MANAGER: new Position({ code: PositionEnum.COMPANY_MARKETING_MANAGER, labelKey: 'LABEL.POSITION.COMPANY_MARKETING_MANAGER' }),
  COMPANY_IT_MANAGER: new Position({ code: PositionEnum.COMPANY_IT_MANAGER, labelKey: 'LABEL.POSITION.COMPANY_IT_MANAGER' }),
  COMPANY_COMMERCIAL: new Position({ code: PositionEnum.COMPANY_COMMERCIAL, labelKey: 'LABEL.POSITION.COMPANY_COMMERCIAL' }),
  COMPANY_CUSTOMER_SUCCESS: new Position({ code: PositionEnum.COMPANY_CUSTOMER_SUCCESS, labelKey: 'LABEL.POSITION.COMPANY_CUSTOMER_SUCCESS' }),
  COMPANY_OPERATIONAL: new Position({ code: PositionEnum.COMPANY_OPERATIONAL, labelKey: 'LABEL.POSITION.COMPANY_OPERATIONAL' }),
  ASSOCIATION_PRESIDENT: new Position({ code: PositionEnum.ASSOCIATION_PRESIDENT, labelKey: 'LABEL.POSITION.ASSOCIATION_PRESIDENT' }),
  ASSOCIATION_ACCOUNTANT: new Position({ code: PositionEnum.ASSOCIATION_ACCOUNTANT, labelKey: 'LABEL.POSITION.ASSOCIATION_ACCOUNTANT' }),
  ASSOCIATION_SECRETARY: new Position({ code: PositionEnum.ASSOCIATION_SECRETARY, labelKey: 'LABEL.POSITION.ASSOCIATION_SECRETARY' }),
  OTHER: new Position({ code: PositionEnum.OTHER, labelKey: 'LABEL.OTHER' }),
};
